import faq from "./components/faq";
import flickity from "./components/flickity";
import glightbox from "./components/glightbox";
import hamburger from "./components/hamburger";
import lazyLoad from "./components/lazyLoad";
import loading from "./components/loading";
import readmore from "./components/readmore";
import signupPopup from "./components/signupPopup";
import popupFormSubmit from "./components/popupFormSubmit";
import getInTouchFormSubmit from "./components/getInTouchFormSubmit";
import InfiniteScroll from "./components/infiniteScroll";
import radioAnswers from "./components/radioAnswers";
import symptomsTest from "./components/symptomsTest";

document.addEventListener("DOMContentLoaded", () => {
    hamburger();
    loading();
    flickity();
    lazyLoad();
    signupPopup();
    faq();
    glightbox();
    readmore();
    popupFormSubmit();
    getInTouchFormSubmit();
    InfiniteScroll();
    radioAnswers();
    symptomsTest();
});
